import styled from "styled-components";

export const BoxStyled = styled.div`
  height: ${(prop) => (prop.height ? prop.height : "")};
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  background-color: white;
  margin-top: ${(prop) => (prop.marginTop ? prop.marginTop : "20px")};
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 10px;
  min-height: 100px;
  min-height: ${(prop) => (prop.minHeight ? prop.minHeight + "px" : "400px")};
  position: relative;
`;

export const Card = styled.div`
  width: 100%;
  height: ${(prop) => (prop.height ? prop.height : "100%")};
  min-height: ${(prop) => (prop.minHeight ? prop.minHeight + "px" : "400px")};
  background: #ffffff;
  border-radius: 8px;
  padding: ${prop => prop.padding ? prop.padding : "10px"};
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
`;

export const ResponsiveDivChart = styled.div`
  width: 100%;
  overflow-x: auto;
  direction: ltr;

`;
